import { render, staticRenderFns } from "./MyInfoMenu.vue?vue&type=template&id=2b88d6e2&scoped=true"
import script from "./MyInfoMenu.vue?vue&type=script&lang=js"
export * from "./MyInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./MyInfoMenu.vue?vue&type=style&index=0&id=2b88d6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88d6e2",
  null
  
)

export default component.exports